import React, { useEffect, useState, useContext } from "react";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";
import UsersApi from "../Classes/API/UsersApi";
import searchUsersReq from "../Classes/Models/Requests/Users/SearchUser";
import UserTypes from "../Classes/Models/Requests/Users/UserTypes";
import MDTypography from "components/MDTypography";
import { LanguageContext } from "App";
const TherapistSelector = ({ setTherapist }) => {
  const [TherapistsSearch, setTherapistsSearch] = useState();
  const { translations, switchLanguage } = useContext(LanguageContext);

  const [OptionSelect, setOptionSelect] = useState([]);

  useEffect(() => {
    GetTherapists().then((res) => {
      setOptionSelect(res);
    });
  }, []);

  const GetTherapists = async (inputValue = "") => {
    let searchReq = new searchUsersReq();
    let userTypes = new UserTypes();

    searchReq.name = inputValue;
    // searchReq.number = PatientsSearch;
    // searchReq.email = PatientsSearch;
    searchReq.userType = userTypes.Therapist;
    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status == "Success") {
      let optionsArr = res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
      if (inputValue) {
        optionsArr = optionsArr.filter((item) =>
          item.label.toLowerCase().includes(inputValue.toLowerCase())
        );
      }
      return optionsArr;
    }
    return [];
  };

  return (
    <div>
      <MDTypography variant="button" fontWeight="regular" color="text">
        {translations.SelectTherapist}
        <AsyncSelect
          isClearable={true}
          loadOptions={(inputValue) => GetTherapists(inputValue)}
          defaultOptions={OptionSelect}
          onInputChange={setTherapistsSearch}
          onChange={(e) => setTherapist(e ? e.value : "")}
          // value={TypeId}
        />
      </MDTypography>
    </div>
  );
};

export default TherapistSelector;
